import React from "react";
import { Header } from "./conponents/header";
import { Filter } from "./conponents/Filter";
import {filterData,apiUrl} from "./data";
import { Cards } from "./conponents/Cards";
import { useState, useEffect} from "react";
import { toast } from 'react-toastify';
import { Spiner } from "./conponents/Spiner";
const App = () => {
  const[courses,setcourses]=useState(null);
  const[loding,setloding]=useState(true);
  const[categary,setcategary]=useState(filterData[0].title)
  useEffect(()=>{
    fetchData()
  },[])
  async function fetchData(){
      setloding(true)
      try{
        let res= await fetch(apiUrl);
        let output=await res.json();
        setcourses(output.data);
      }
      catch(error){
            toast.error("Data Not Found")
      }
      setloding(false);
    }
  return <div className="w-full min-h-screen bg-bgDark2">
    <Header></Header>
    <Filter filterData={filterData} setcategary={setcategary} categary={categary}></Filter>
    <div className="flex justify-center items-center">
    {
      
      loding ? (
        <Spiner></Spiner>
        ) :(
          <Cards
           data={courses}
           categary={categary}
          
          ></Cards>
        )

    }
      
    </div>

    
  </div>;
};

export default App;
